// extracted by mini-css-extract-plugin
export var TooltipArrow = "LabelCell-module--TooltipArrow--8801e";
export var TooltipContent = "LabelCell-module--TooltipContent--55063";
export var labelCell = "LabelCell-module--labelCell--72706";
export var labelCell__paragraph = "LabelCell-module--labelCell__paragraph--13b96";
export var slideUpAndFade = "LabelCell-module--slideUpAndFade--7b859";